import React from "react";
import { Link } from "react-router-dom";
import { LANDING } from "@/constants/testIds";
import { IKO, IKO_KEYS, KILI } from "@/lib/design";

// Public marketing landing — Night theme.
export default function Landing() {
  return (
    <div className="theme-night min-h-screen" style={{ background: "var(--bg-night)", color: "var(--text-night)" }}>
      <div className="mx-auto max-w-6xl px-6 pt-10">
        <header className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="compass-mark" />
            <span className="wordmark text-2xl">watu wako</span>
          </div>
          <nav className="hidden gap-6 text-sm sm:flex" style={{ color: "var(--text-muted-night)" }}>
            <Link to="/app" className="hover:text-white transition-colors">Discover</Link>
            <Link to="/submit" className="hover:text-white transition-colors">Submit</Link>
            <Link to="/admin/login" data-testid={LANDING.loginLink} className="hover:text-white transition-colors">Admin</Link>
          </nav>
        </header>

        <section className="mt-24 max-w-3xl">
          <p className="eyebrow" style={{ color: "var(--text-muted-night)" }}>WATU WAKO · NAIROBI</p>
          <h1 className="font-display mt-4 text-5xl leading-[1.05] sm:text-6xl">
            every event in nairobi,
            <br />
            <span className="kili-underline" style={{ color: "var(--bg-night)" }}>rated.</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg" style={{ color: "var(--text-muted-night)" }}>
            The score the city trusts. Posters, whispers and self-submissions arrive from all corners — a human curates every one before it's live.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              data-testid={LANDING.discoveryLink}
              to="/app"
              className="inline-flex items-center rounded-full px-6 py-3 text-sm font-semibold transition-colors"
              style={{ background: KILI, color: "#1A1A30" }}
            >
              What's on in Nairobi →
            </Link>
            <Link
              data-testid={LANDING.submitLink}
              to="/submit"
              className="inline-flex items-center rounded-full border px-6 py-3 text-sm font-semibold transition-colors hover:bg-white/10"
              style={{ borderColor: "var(--line-night)", color: "var(--text-night)" }}
            >
              Submit an event
            </Link>
          </div>
        </section>

        <section className="mt-24 grid grid-cols-2 gap-6 pb-24 md:grid-cols-4">
          {IKO_KEYS.map((k) => {
            const t = IKO[k];
            return (
              <div
                key={k}
                className="rounded-2xl border p-5 transition-transform hover:-translate-y-1"
                style={{ borderColor: "var(--line-night)", background: "var(--card-night)" }}
              >
                <div className="flex items-center gap-2">
                  <span className="h-3 w-3 rounded-full" style={{ background: t.hex }} />
                  <p className="font-display text-lg font-bold">{t.label}</p>
                </div>
                <p className="mt-2 text-sm" style={{ color: "var(--text-dim-night)" }}>{t.desc}</p>
              </div>
            );
          })}
        </section>
      </div>
    </div>
  );
}
